import {
    collection,
    doc,
    addDoc,
    setDoc,
    getDoc,
    getDocs,
    updateDoc,
    deleteDoc,
    query,
    where,
} from 'firebase/firestore';
import { db } from './config';

export const addDocument = async (collectionName, data) => {
    const docRef = await addDoc(collection(db, collectionName), {
        ...data,
        createdAt: new Date(),
        updatedAt: new Date(),
    });
    return docRef.id;
};

export const setDocument = async (collectionName, docId, data, merge = false) => {
    await setDoc(doc(db, collectionName, docId), data, { merge });
};

export const getDocumentById = async (collectionName, docId) => {
    const docSnap = await getDoc(doc(db, collectionName, docId));
    return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null;
};

export const getCollectionDocuments = async (collectionName) => {
    const querySnapshot = await getDocs(collection(db, collectionName));
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const queryDocuments = async (collectionName, conditions = []) => {
    let q = collection(db, collectionName);
    if (conditions.length > 0) {
        const whereConditions = conditions.map(([field, op, value]) => where(field, op, value));
        q = query(q, ...whereConditions);
    }
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const updateDocument = async (collectionName, docId, updates) => {
    await updateDoc(doc(db, collectionName, docId), {
        ...updates,
        updatedAt: new Date(),
    });
};

export const deleteDocument = async (collectionName, docId) => {
    await deleteDoc(doc(db, collectionName, docId));
};

export default db;
